import {
  ArrowDownCircle,
  ArrowLeftCircle,
  ArrowRightCircle,
} from 'react-feather'
import { Card, CardText, Col, List, Row } from 'reactstrap'

// css
import { useSelector } from 'react-redux'
import { tags } from 'utils/tags'
import './style.scss'

import BreadCrumbs from 'components/breadcrumbs'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import {
  URL_406,
  URL_APPROVAL_BUY,
  URL_APPROVAL_SELL,
  URL_APPROVAL_WITHDRAWAL,
} from 'utils/pathUrl'
import { BUSINESS_MYAPPROVAL, READ } from 'utils/subjectActions'
import PMBTabSwitcher from 'components/PMBTabSwitcher'

const ApprovalPage = () => {
  const nav = useNavigate()
  let location = useLocation()
  const access = useAbilityAccess({
    action: READ,
    subject: BUSINESS_MYAPPROVAL,
  })
  const { countData } = useSelector((s) => s.approval)

  const [activeTab, setActiveTab] = useState('pembelian')

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
    if (tabKey === 'pembelian') {
      nav(`/${URL_APPROVAL_BUY}`)
    } else if (tabKey === 'penjualan') {
      nav(`/${URL_APPROVAL_BUY}/${URL_APPROVAL_SELL}`)
    } else {
      nav(`/${URL_APPROVAL_BUY}/${URL_APPROVAL_WITHDRAWAL}`)
    }
  }

  useEffect(() => {
    if (location?.pathname === `/${URL_APPROVAL_BUY}`) {
      setActiveTab('pembelian')
    } else if (
      location?.pathname === `/${URL_APPROVAL_BUY}/${URL_APPROVAL_SELL}`
    ) {
      setActiveTab('penjualan')
    } else {
      setActiveTab('penarikan-uang')
    }
  }, [location])

  if (!access) {
    return <Navigate to={URL_406} replace={true} />
  }

  return (
    <div className="w-100 px-3 pb-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Persetujuan'} />
      </div>
      <Card body className="border-0 shadow-sm">
        <CardText tag="h5" className="pb-2 py-2">
          Permintaan Persetujuan
        </CardText>
        <div className="mb-2 d-flex justify-content-start">
          <PMBTabSwitcher
            activeTab={activeTab}
            tabs={[
              {
                key: 'pembelian',
                label: `Pembelian ${countData[tags.request_buy] ?? 0}`,
              },
              {
                key: 'penjualan',
                label: `Penjualan ${countData[tags.request_sell] ?? 0}`,
              },
              {
                key: 'penarikan-uang',
                label: `Penarikan Uang ${countData[tags.request_withdrawal] ?? 0}`,
              },
            ]}
            onTabChange={handleTabChange}
          />
        </div>
        <Outlet />
      </Card>
    </div>
  )
}

export default ApprovalPage
